// extracted by mini-css-extract-plugin
export default {"reset":"xtWOV3","visuallyHidden":"rypOq4"};